import styled from "styled-components";
import { InviteIcon } from "@assets";
import {
  Button as AntButton
} from 'antd';



export const InviteLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 16px 0;
`;

export const ChainIconContainer = styled.div`
  margin: 119px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 84px;
  height: 84px;
`
export const ChainIcon = styled(InviteIcon)`

`
export const InviteLinkTitle = styled.p`
  margin: 16px 0 0 0;
  color: #808080;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const CreateLinkButton = styled(AntButton)`
  margin: 20px 0 0 0;
  width: 171px !important;
  height: 52px;
  border-radius: 27px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  color: #F7F7F7;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  :hover {
    background-color: #6d1304 !important;
  }

  svg{
    width: 24px;
    height: 24px;
  }
`

export const TermsAndConditionsContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #DEDEDE;
  background: #F7F7F7;
  padding: 16px;
  margin: 24px 0 0 0;
`

export const InviteLinkTerm = styled.p`
  text-align: center;
  margin: 0px 0 0 10px;
  padding: 0px;
  color: #101415;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const InviteLinkTerms = styled.span`
  font-size: 14px;
  margin: 0px;
  padding: 0px;
  color: #808080;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const CopyTitle = styled.p`
  margin-bottom: 10px;
  color: #C21C05;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const CopyLink = styled.a`
  display: block;
  margin-bottom: 20px;
  color: #535B5D;
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  :hover {
    color: #535B5D;
  }
`;

